import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import { withHeaderTitle } from "../../../components/Header/HeaderTitle";
import BlockUi from "react-block-ui";
import ChartCustom from "../../GoogleChart/ChartCustom";
import { getChart } from "../../../services/dashboardServices/serviceProblemGraphics";
// estilos.
import "react-block-ui/style.css";
import "../Dashboard.scss";

const MutualSegurosScreen = (props) => {
  props.setHeaderTitle("Ingresos y problemas económicos");
  const isMounted = useRef(false);
  const [blocking, setBlocking] = useState(false);
  const filters = props.filters;
  const onSearch = props.onSearch;
  const setOnSearch = props.setOnSearch;
  // graficos.
  const [columnsChart39, setColumnsChart39] = useState({ data: [], titles: [] }); 
  const [columnsChart41, setColumnsChart41] = useState({ data: [], titles: [] }); 
  const [columnsChart43, setColumnsChart43] = useState({ data: [], titles: [] }); 
  const [columnsChart45, setColumnsChart45] = useState({ data: [], titles: [] }); 

  const loadCharLife39 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart39-ahorro" };
    const data = await getChart(config); 
    const titles = [ 'Elección', '% Sí',  {role:'annotation'}];
    
    if (isMounted.current) {
      setColumnsChart39({ 
        data: data.rows, 
        titles: titles,
        format: 'FOR',
        referencias: data.referencias,
      });
    }
    
    setBlocking(false);
  }; 

  const loadCharLife41 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart41-ahorro" };
    const data = await getChart(config);
    // console.log(data);
    const iterableTitles = data.medicionList.reduce((acc, current) => {
      return acc = [ ...acc,  `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);
    
    if (isMounted.current) {
      setColumnsChart41({ 
        data: data.rows, 
        titles: iterableTitles 
      });
    }
    
    setBlocking(false);
  };  
  
  const loadCharLife43= async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart43-ahorro" };
    const data = await getChart(config);
    // console.log(data);
    const iterableTitles = data.medicionList.reduce((acc, current) => {
      return acc = [ ...acc,  `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);

    if (isMounted.current) {
      setColumnsChart43({ 
        data: data.rows, 
        titles: iterableTitles 
      });
    } 

    setBlocking(false);
  };
  
  const loadCharLife45 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart45-ahorro" };
    const data = await getChart(config);
    const titles = [ 'Elección', '% Sí',  {role:'annotation'}];
    
    if (isMounted.current) {
      setColumnsChart45({ 
        data: data.rows, 
        titles: titles,
        format: 'FOR',
        referencias: data.referencias,
      });
    }
    
    setBlocking(false);
  };

  const loadCharts = () => {
    loadCharLife39();
    loadCharLife41();
    loadCharLife43();
    loadCharLife45();
    setOnSearch(false);
  }

  useEffect(() => {
    isMounted.current = true;
    loadCharts();
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    loadCharts();
  }, [ onSearch ])

  return (
    <BlockUi tag="div" blocking={blocking}>
       {/* gráfico lamina 39. */}
       <div className="row mb-2">
        {columnsChart39.data.length > 0 && (
          <ChartCustom 
            subTitle="¿Estás actualmente ahorrando de manera voluntaria?"
            chartComment="Entre quienes ahorran de manera voluntaria."
            dataChart={columnsChart39.data}
            titles={columnsChart39.titles}
            applyFormat={columnsChart39.format}
            referencias={columnsChart39.referencias}
            mediaQueries={{
              lx: "6",
              md: "6",
              xs: "12",
            }}
          />
        )}
        
        {/* gráfico lamina 45. */}
        {columnsChart45.data.length > 0 && (
          <ChartCustom 
            subTitle="En los próximos 12 meses ¿Esperas ahorrar algo de dinero?"
            chartComment="Entre quienes no ahorran de manera voluntaria."
            dataChart={columnsChart45.data}
            titles={columnsChart45.titles} 
            applyFormat={columnsChart45.format}
            referencias={columnsChart45.referencias}
            mediaQueries={{
              lx: "6",
              md: "6",
              xs: "12",
            }}
          />
        )}
      </div>

       {/* gráfico lamina 41. */}
       <div className="row mb-2">
        {columnsChart41.data.length > 0 && (
          <ChartCustom 
            subTitle="¿Para qué estas ahorrando?"
            chartComment={'Entre quienes ahorran de manera voluntaria.'}
            dataChart={columnsChart41.data}
            titles={columnsChart41.titles} 
          />
        )}
      </div>

      {/* gráfico lamina 43. */}
      <div className="row mb-2">
      {columnsChart43.data.length > 0 && (
        <ChartCustom 
          subTitle="¿Por qué no ahorras?"
          chartComment={'Entre quienes no ahorran de manera voluntaria.'}
          dataChart={columnsChart43.data}
          titles={columnsChart43.titles} 
        />
        // Los valores de 2024 a nivel total parecen estar pegados a 2023, es raro porque al usar los filtros los valores están bien en 2024, es solo la vista a total. ¿Podemos revisarlo?
      )}
      </div>
    </BlockUi>
  );
};

export default withNamespaces("translations")(
  withHeaderTitle(MutualSegurosScreen)
);
